import {
    Typography,
  } from '@material-ui/core';

const Header = (props) => <Typography color="textPrimary" style={{marginBottom:"8px"}}><b>{props.title}</b></Typography>
export default Header;